<section class="py-4">
    <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
        <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
        <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
        </div>
    </div>

    <div class="row" *ngIf="!tableLoading">
        <div class="col-16 p-2">
            <h1>{{faturamentoDetalhado.unidade.nomeFantasia}}</h1>
        </div>
    </div>

    <div class="row" *ngIf="!tableLoading && faturamentoDetalhado.outrasUnidadeFaturantes.length>0">
        <div class="col-2 p-2">
            Faturamento Filiais
        </div>
    </div>
    <div class="row" *ngIf="!tableLoading && faturamentoDetalhado.outrasUnidadeFaturantes.length>0">
        <div class="col-2 p-2" *ngFor="let u of faturamentoDetalhado.outrasUnidadeFaturantes">
            <span data-toggle="tooltip" data-placement="bottom" title="Informações de faturamento">
            <a [routerLink]="['/faturamento', u.uuid]" class="btn btn-sm btn-info btn-icon">
                {{u.nomeFantasia}}
            </a>
        </span>
        </div>
    </div>

    <div class="mx-2 my-4 mx-lg-4" *ngIf="!tableLoading">
        <button (click) = "toggleGerarFaturamento()" class="btn btn-sm px-5 btn-success btn-icon">
            <i class="mdi mdi-arrow-right-drop-circle-outline"></i>
            <span>GERAR NOVO FATURAMENTO</span>
        </button>
    </div>

    <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th>Periodo Faturamento</th>
                <th>Referênte</th>

                <th>Qtd Consulta</th>
                <th>% Anterior</th>
                <th>Valor</th>
                <th>% Anterior</th>
                <th>Clientes</th>
                <th>Verificados</th>
                <th>Pendentes</th>
                <th>Não Faturados</th>
                <th>Sem Consumo</th>

                <th w class="text-center py-2">
                    <!-- <button (click)="iniciarFaturamento()" class="btn btn-sm px-5 btn-success btn-icon">
                        <i class="mdi mdi-plus"></i>
                        <span>Iniciar Faturamento</span>
                    </button> -->
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="faturamentoDetalhado.listaFaturas.length==0">
                <td class="text-center py-5 text-secondary w-500" colspan="12">
                Sem registros
                </td>
            </tr>
            <tr *ngFor="let r of faturamentoDetalhado.listaFaturas">
                <td>{{r.periodoFaturamento}}</td>
                <td>{{r.mesRederencia | number:'2.0-0'}}/{{r.anoReferencia}}</td>

                <td>{{r.quantidadeConsulta}}</td>
                <td>{{r.indicadorCrescimentoQuantidade | number:'1.2-2'}}%</td>

                <td>R$ {{r.valorTotal | number:'1.2-2'}}</td>
                <td>{{r.indicadorCrescimentoValor | number:'1.2-2'}}%</td>

                <td>{{r.totalClientes}}</td>
                <td>{{r.totalClientesVerificados}}</td>
                <td>{{r.totalClientesPendenteVerificacao}}</td>
                <td>{{r.totalClientesnaofaturados}}</td>
                <td>{{r.totalClientessemconsumo}}</td>

                <td class="py-1">
                <div class="d-flex align-items-center justify-content-end">
                    <span data-toggle="tooltip" data-placement="bottom" title="Visualizar detalhe de faturamento">
                        <a [routerLink]="['/faturamento','detalhe', r.uuid]" class="btn btn-sm btn-info btn-icon"
                        style="margin-left: 2px; margin-right: 2px;">
                        <i class="mdi mdi-eye"></i>
                        </a>
                    </span>
                    <!-- BOTÃO DE DELETAR FATURAMENTO -
                    <span data-toggle="tooltip" data-placement="bottom" title="Excluir faturamento">
                        <a (click)="deletarFaturamento(r)" class="btn btn-sm btn-danger btn-icon" style="margin-left: 2px; margin-right: 2px;">
                        <i style="color: white;" class="mdi mdi-delete"></i>
                        </a>
                    </span>
                    -->
                </div>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
        <!-- <div class="card-footer bg-white row justify-content-between">
            <div class="pb-2 pb-sm-0">
                <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total" [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
                </ngb-pagination>
            </div>
            <div class="pb-2 pb-sm-0">
                <div class="btn-group" role="group">
                <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}" type="button" class="btn btn-outline-primary">10</button>
                <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}" type="button" class="btn btn-outline-primary">25</button>
                <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}" type="button" class="btn btn-outline-primary">50</button>
                <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}" type="button" class="btn btn-outline-primary">100</button>
                </div>
            </div>
        </div> -->
    </div>
</section>

<!-- [breakpoints]="{'960px': '75vw', '640px': '100vw'}" -->
<p-dialog header="Gerar Novo Faturamento" [modal]="true" [draggable]="false" [resizable]="false"
[(visible)]="displayGerarFaturamento"  [style]="{width: '50vw'}"
[transitionOptions]="'1ms'">
    <ng-template pTemplate="content">
        <div class="row">
            <div class="col-md-4">
                <span style="font-weight: bold;">Periodo Faturamento: </span>
                <p-dropdown appendTo="body" [(ngModel)]="novoFaturamento.periodoFaturamento"
                    [options]="novoFaturamento.periodos" placeholder="Selecione">
                    <ng-template let-option pTemplate="item">
                        <span>{{option.label}}</span>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="col-md-4">
                <span style="font-weight: bold;">Mês Referênte: </span>
                <p-dropdown appendTo="body" [(ngModel)]="novoFaturamento.mesReferente"
                    [options]="novoFaturamento.meses" placeholder="Selecione">
                    <ng-template let-option pTemplate="item">
                        <span>{{option.label}}</span>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="col-md-4">
                <span style="font-weight: bold;">Ano Referênte: </span>
                <input [(ngModel)]="novoFaturamento.anoReferente" type="number" id="anoReferente" name="anoReferente" min="2000" max="3000"
                class="form-control">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" [disabled]='!novoFaturamento.isValid()'
        (click)="gerarNovoFaturamento()" label="Gerar" styleClass="p-button-outlined p-button-success"></p-button>
        <p-button icon="pi pi-times" (click)="toggleGerarFaturamento()" label="Cancelar" styleClass="p-button-outlined p-button-danger">
        </p-button>
    </ng-template>
</p-dialog>
